(function () {
  function initVelouraFilters(root) {
    const scope = root || document;
    const buttons = scope.querySelectorAll('[data-veloura-filter]');
    const cards = scope.querySelectorAll('[data-veloura-product]');
    if (!buttons.length || !cards.length) return;

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        const filter = button.getAttribute('data-veloura-filter');
        buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
        cards.forEach((card) => {
          const category = card.getAttribute('data-category');
          card.style.display = filter === 'all' || category === filter ? '' : 'none';
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVelouraFilters(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVelouraFilters(event.target);
  });
})();

(function () {
  function normalizeSearch(value) {
    return (value || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function getStellaProductCards() {
    return Array.from(document.querySelectorAll('[data-veloura-product]')).map(function (card, index) {
      if (!card.id) card.id = 'stella-product-card-' + (index + 1);
      var title = card.getAttribute('data-search-title') || (card.querySelector('.product-title-row span:first-child') || {}).textContent || '';
      var price = card.getAttribute('data-search-price') || (card.querySelector('.product-title-row span:last-child') || {}).textContent || '';
      var category = card.getAttribute('data-search-category') || (card.querySelector('.product-category') || {}).textContent || '';
      var description = card.getAttribute('data-search-description') || (card.querySelector('.product-desc') || {}).textContent || '';
      var url = card.getAttribute('data-search-url') || card.getAttribute('href') || ((card.querySelector("a[href*='/products/']") || {}).href || '');
      var image = card.getAttribute('data-search-image') || '';
      if (!image) {
        var productImage = card.querySelector('.product-image');
        if (productImage) {
          var bg = window.getComputedStyle(productImage).backgroundImage || '';
          image = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
        }
      }
      return { card: card, id: card.id, title: title.trim(), price: price.trim(), category: category.trim(), description: description.trim(), url: url, image: image };
    }).filter(function (item) { return item.title; });
  }

  function initStellaSearch() {
    var drawer = document.querySelector('[data-stella-search]');
    if (!drawer || drawer.getAttribute('data-initialized') === 'true') return;
    drawer.setAttribute('data-initialized', 'true');

    var input = drawer.querySelector('[data-stella-search-input]');
    var form = drawer.querySelector('[data-stella-search-form]');
    var live = drawer.querySelector('[data-stella-search-live]');
    var openButtons = document.querySelectorAll('[data-open-search]');
    var closeButtons = drawer.querySelectorAll('[data-stella-search-close]');

    function openDrawer(event) {
      if (event) event.preventDefault();
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(function () { if (input) input.focus(); }, 40);
      renderLiveResults(input ? input.value : '');
    }

    function closeDrawer() {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function scrollToProduct(id) {
      var target = document.getElementById(id);
      if (!target) return;
      closeDrawer();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('stella-search-highlight');
      window.setTimeout(function () { target.classList.remove('stella-search-highlight'); }, 1800);
    }

    function renderLiveResults(query) {
      if (!live) return [];
      var cards = getStellaProductCards();
      var q = normalizeSearch(query);
      if (!q) {
        live.innerHTML = '<p>Type a heel name to see matching products instantly.</p>';
        return [];
      }

      if (!cards.length) {
        live.innerHTML = '<p>Press Search to look through all products in the boutique.</p>';
        return [];
      }

      var matches = cards.filter(function (item) {
        return normalizeSearch(item.title).indexOf(q) !== -1 || normalizeSearch(item.description).indexOf(q) !== -1 || normalizeSearch(item.category).indexOf(q) !== -1;
      });

      if (!matches.length) {
        live.innerHTML = '<p>No heel matched that name. Try another word like <strong>Noir</strong>, <strong>Capri</strong>, <strong>Mule</strong> or <strong>Sandal</strong>.</p>';
        return [];
      }

      live.innerHTML = matches.slice(0, 10).map(function (item) {
        var thumb = item.image ? '<img class="stella-search-result-image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span class="stella-search-result-image stella-search-result-image-empty" aria-hidden="true"></span>';
        return '<a href="' + escapeHtml(item.url || ('#' + item.id)) + '" class="stella-search-result"><span class="stella-search-result-copy"><small>' + escapeHtml(item.category || 'Heel') + '</small><strong>' + escapeHtml(item.title) + '</strong><span>' + escapeHtml(item.price) + '</span></span>' + thumb + '</a>';
      }).join('');

      return matches;
    }

    function escapeHtml(value) {
      return (value || '').replace(/[&<>'"]/g, function (char) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
      });
    }

    openButtons.forEach(function (button) { button.addEventListener('click', openDrawer); });
    closeButtons.forEach(function (button) { button.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !drawer.hidden) closeDrawer(); });
    if (input) input.addEventListener('input', function () { renderLiveResults(input.value); });
    if (form) {
      form.addEventListener('submit', function (event) {
        var cards = getStellaProductCards();
        if (!cards.length) return;
        event.preventDefault();
        var matches = renderLiveResults(input ? input.value : '');
        if (matches.length === 1 && matches[0].url) { window.location.href = matches[0].url; } else if (matches.length === 1) { scrollToProduct(matches[0].id); }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStellaSearch);
  } else {
    initStellaSearch();
  }
})();


(function () {
  function initStellaInternalScroll(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('[data-stella-scroll-link], a[href="#shop"], a[href="#collections"]');
    links.forEach(function (link) {
      if (link.getAttribute('data-scroll-initialized') === 'true') return;
      link.setAttribute('data-scroll-initialized', 'true');
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history && history.replaceState) history.replaceState(null, '', href);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initStellaInternalScroll(document); });
  } else {
    initStellaInternalScroll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initStellaInternalScroll(event.target);
  });
})();


/* Stella 04 Jun View All: reveal remaining homepage products, no link opening */
(function () {
  function initStellaViewAll() {
    var buttons = document.querySelectorAll('[data-stella-view-all]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        var section = button.closest('#shop') || document.querySelector('#shop');
        if (!section) return;

        var grid = section.querySelector('.product-grid');
        if (!grid) return;

        grid.classList.add('show-all-products');
        button.closest('.view-all-wrap').style.display = 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStellaViewAll);
  } else {
    initStellaViewAll();
  }
})();


/* Stella final View All fix: reveal products on homepage, never navigate */
(function () {
  function initFinalStellaViewAll() {
    document.querySelectorAll('[data-stella-view-all]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var shop = button.closest('#shop') || document.querySelector('#shop');
        if (!shop) return false;

        var grid = shop.querySelector('[data-stella-product-grid]') || shop.querySelector('.product-grid');
        if (!grid) return false;

        grid.classList.add('show-all-products');
        button.setAttribute('aria-expanded', 'true');

        var wrap = button.closest('[data-stella-view-all-wrap]') || button.closest('.view-all-wrap');
        if (wrap) wrap.style.display = 'none';

        return false;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFinalStellaViewAll);
  } else {
    initFinalStellaViewAll();
  }
})();


/* Stella final visible View All: no navigation, reveal hidden products in homepage grid */
(function () {
  function initStellaViewAllVisible() {
    document.querySelectorAll('[data-stella-view-all]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var shop = button.closest('#shop') || document.querySelector('#shop');
        if (!shop) return false;

        var grid = shop.querySelector('[data-stella-product-grid]') || shop.querySelector('.product-grid');
        if (!grid) return false;

        grid.classList.add('show-all-products');
        button.setAttribute('aria-expanded', 'true');

        return false;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStellaViewAllVisible);
  } else {
    initStellaViewAllVisible();
  }
})();


/* Stella View All TRUE FIX: reveal products on homepage only */
(function () {
  function initStellaViewAllTrueFix() {
    document.querySelectorAll('#shop [data-stella-view-all]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var shop = document.querySelector('#shop');
        if (!shop) return false;

        var grid = shop.querySelector('[data-stella-product-grid]') || shop.querySelector('.product-grid');
        if (!grid) return false;

        grid.classList.add('show-all-products');

        var wrap = shop.querySelector('[data-stella-view-all-wrap]');
        if (wrap) wrap.style.display = 'none';

        return false;
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStellaViewAllTrueFix);
  } else {
    initStellaViewAllTrueFix();
  }
})();
